import React, { useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import { sanitizeWorkflowHtmlForDisplay } from '../../../shared/utils/sanitizeWorkflowHtml';
import { resolveMaintellaMediaInHtml } from '../../../shared/utils/resolveWorkflowMediaHtml';
import useMediaLibrary from '../../hooks/useMediaLibrary';

export default function WorkflowHtmlPreview({ html, className }) {
  const [previewHtml, setPreviewHtml] = useState('');
  // enabled: false - this component needs fetchDownloadUrl, not the library listing,
  // and the hook fetches the whole list on mount otherwise.
  const { fetchDownloadUrl } = useMediaLibrary({ enabled: false });

  useEffect(() => {
    let cancelled = false;

    const load = async () => {
      const resolved = await resolveMaintellaMediaInHtml(html, fetchDownloadUrl);
      if (!cancelled) setPreviewHtml(resolved);
    };

    load();
    return () => {
      cancelled = true;
    };
  }, [html, fetchDownloadUrl]);

  return (
    <div
      className={className}
      dangerouslySetInnerHTML={{ __html: sanitizeWorkflowHtmlForDisplay(previewHtml || html || '') }}
    />
  );
}

WorkflowHtmlPreview.propTypes = {
  html: PropTypes.string,
  className: PropTypes.string,
};

WorkflowHtmlPreview.defaultProps = {
  html: '',
  className: '',
};
